<template>
    <div class="flex float-left vertical-center">
        <vs-button size="small" icon-pack="feather" icon="icon-edit" @click="editRecord" color="success" class="mr-2"></vs-button>
        <vs-button size="small" icon-pack="feather" icon="icon-trash" @click="deleteRecord" color="danger"></vs-button>
    </div>
</template>

<script>
    import Vue from "vue";

    export default Vue.extend({
        name: "ActionTableEditDelAgGridComponent",
        data() {
            return {
            }
        },
        methods: {
            deleteRecord() {
                this.$root.$emit("delete-from-ActionTableEditDelAgGridComponent", this.params.value)
            },
            editRecord() {
                this.$root.$emit("edit-from-ActionTableEditDelAgGridComponent", this.params.value)
            },
        },
        created() {
        }
    })
</script>

<style scoped>
    .vertical-center {
        margin: 0;
        position: absolute;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
</style>